export default "__VITE_ASSET__BTaN2vqw__"